import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acesso-negado',
  templateUrl: './acesso-negado.component.html'
})
export class AcessoNegadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
